import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { myFont } from '../../assets/webfonts/Vazir-normal';
import { enumHelper } from '../../utils';

const ExportTableToPdf = ({ records, columns, title, name, status, extra }) => {
  const exportPDF = () => {
    const unit = 'pt';
    const size = 'A4'; // Use A1, A2, A3 or A4
    const orientation = 'portrait'; // portrait or landscape

    const marginLeft = 300;
    const doc = new jsPDF(orientation, unit, size);
    doc.addFileToVFS('Vazir.ttf', myFont);
    doc.addFont('Vazir.ttf', 'Vazir', 'normal');
    doc.setFont('Vazir');
    doc.setFontSize(12);

    const headers = columns.reverse().map(header => header.title);

    const data = records.reverse().map((elt, i) => {
      return columns.map(col => {
        if (col.dataIndex === 'num') {
          return `${i + 1}`;
        }
        if (Array.isArray(elt[col.dataIndex])) {
          return elt[col.dataIndex].map(item => item.num).join(',');
        }
        if (col.dataIndex === 'status' && status) {
          return enumHelper.convertEnumValueToTitle(status, elt[col.dataIndex]);
        }
        return `${elt[col.dataIndex]}`;
      });
    });

    let content = {
      startY: 130,
      head: [headers],
      body: data,
      headStyles: {
        fontSize: 5,
        font: 'Vazir',
        fillColor: '#0052cc',
      },
      columnStyles: {
        6: { cellWidth: 23 },
        9: { cellWidth: 25 },
        10: { cellWidth: 25 },
      },
      bodyStyles: { font: 'Vazir', textAlign: 'center', fontSize: 6 },
      styles: {
        overflow: 'linebreak',

        valign: 'middle',
        direction: 'rtl',
        halign: 'center',
      },
      theme: 'grid',
    };
    console.log(extra);
    console.log(content);
    doc.text(title, marginLeft, 40, { align: 'center' });
    if (extra) {
      doc.autoTable(extra.content);
    }
    doc.autoTable(content);
    doc.setProperties({
      title: 'Report-Sell',
      subject: 'Report-Sell',
      author: 'Rsee',
      creator: 'Rsee',
    });
    doc.save(name);
  };

  return (
    <div className='d-flex justify-content-end'>
      <button className='btn btn-primary  m-2' onClick={exportPDF}>
        خروجی Pdf
      </button>
    </div>
  );
};

export default ExportTableToPdf;
